// extracted by mini-css-extract-plugin
var _1 = "PostSectionHeader-module__animateUploadProgressBarWidth--I7wrH";
var _2 = "PostSectionHeader-module__animatedBackground--RYGVn";
var _3 = "PostSectionHeader-module__content--VhLHL";
var _4 = "PostSectionHeader-module__controls--tNo_Z";
var _5 = "PostSectionHeader-module__controlsContainer--a8_HO";
var _6 = "PostSectionHeader-module__header--_0YNF";
var _7 = "PostSectionHeader-module__mobileControlsToggle--Ps0Bc";
var _8 = "PostSectionHeader-module__showMobileControls--V87KA";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "controls", _5 as "controlsContainer", _6 as "header", _7 as "mobileControlsToggle", _8 as "showMobileControls" }
